module.exports = __webpack_public_path__ + "static/media/JoanaDiasHover.a488537e.png";